import { render } from "./Signage.vue?vue&type=template&id=3be0f33a&scoped=true&ts=true"
import script from "./Signage.vue?vue&type=script&lang=ts"
export * from "./Signage.vue?vue&type=script&lang=ts"

import "./Signage.vue?vue&type=style&index=0&id=3be0f33a&lang=css"
import "./Signage.vue?vue&type=style&index=1&id=3be0f33a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be0f33a"]])

export default __exports__